import { effect, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export interface Breadcrumb {
  label: string;
  link?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class DynamicTitleService {
  private defaultTitle = 'Kekeno Surveys';
  pageTitle = signal('Kekeno Surveys');
  breadcrumbs = signal<Breadcrumb[]>([]);

  constructor() {
    const router = inject(Router);

    effect(() => {
      router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.pageTitle.set(this.defaultTitle);
          this.breadcrumbs.set([]);
        });
    });
  }

  setTitle(title: string) {
    this.pageTitle.set(title);
    this.breadcrumbs.set([{ label: title }]);
  }

  setBreadcrumbs(crumbs: Breadcrumb[]) {
    if (crumbs.length > 0) {
      this.pageTitle.set(crumbs[0].label);
    }
    this.breadcrumbs.set(crumbs);
  }
}
